import { useReactiveVar } from "@apollo/client";
import { localRecordingToolState } from "../../../../model";
import type { RecordingState } from "../../../../../logic/recordingTool/recordingToolSession";

export const useRecordingState = (): RecordingState => {
    return useReactiveVar(localRecordingToolState);
};
